import React from 'react'

import Icon from '../data/icon.png';
const Entete = () => {
    return (
        <div className="flex justify-between gap-3">
            <div className="flex flex-col gap-3">
                <h1>Ecoles privées Al Dighah - MOUTEVEWIGOUNE</h1>
                <h1>Jardin-Primaire-Collège-Secondaire</h1>
                <h2>Tel: 22201111 - 38004050 - 22004050</h2>
            </div>
            <img className="mx-auto h-28 w-auto" src={Icon} alt="Your Company" />
            <div className="flex flex-col text-right gap-3">
                <h1>مجمع مدارس الدقة الحرة - المـتـفوقـون  </h1>
                <h1> روضة - ابتدائية - إعدادية - ثانوية </h1>
                <h2> 22201111 - 38004050 - 22004050: الهاتف</h2>
            </div>
        </div>
    )
}

export default Entete